/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default } from './tag/internal/removable';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default as SimpleTag } from './tag/internal/simple';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { RemovableTag } from './tag/removable-tag';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { RemovableTagProps } from './tag/internal/removable';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { SimpleTagProps } from './tag/internal/shared/types';

/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { AppearanceType, MigrationFallback, TagColor } from './types';

// Export new visual refresh components
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default as AvatarTag } from './tag-new/avatar-tag';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default as TagDropdownTrigger } from './tag-new/tag-dropdown-trigger';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { NewTagColor, TagNewProps, TagDropdownTriggerProps } from './tag-new/types';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { AvatarTagProps, AvatarRenderProps, TypesOfAvatars } from './tag-new/avatar-tag';
